// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxView_checkbox__a8aEo","options":"CheckboxView_options__1QHyY","option":"CheckboxView_option__3xpzh"};